import { ErrorBoundary } from 'components/ErrorBoundary';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'core/store/store';
import { subscriptionPaymentStatusSelector } from 'state/subscription/selectors';
import { SubscriptionPaymentStatus } from 'state/subscription/reducer';
import { VendorSubscriptionNewCard } from './VendorSubscriptionNewCard';
import { Text, TextTypography } from 'components/Text/Text';
import { ShopTypeName, SupportedCountryCodes } from 'types';
import { makeSubscriptionRequestPriorityAction, makeSubscriptionResumeAction } from 'state/subscription/actions';
import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { TranslatableEnum } from 'components/T/GetTranslationForEnum';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { isUIEnabledSelector } from 'state/app/selectors';
import {
    RequestInvoiceForm,
    RequestInvoiceFormData,
    USER_INVOICE_DATA,
} from '../../../forms/RequestInvoiceForm/RequestInvoiceForm';
import { getRequest } from '../../../core/axios/axios';
import { Endpoint } from '../../../Endpoint';
import { captureException } from '@sentry/nextjs';
import i18n from '../../../../i18n';
import { getTranslationForEnum } from '../../../components/T/GetTranslationForEnum';

interface VendorSubscriptionDialogProps {
    rate: ShopTypeName;
    isoCode: SupportedCountryCodes;
    onClose: () => void;
}
const useStyles = makeStyles(theme => ({
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    dialog: {
        display: 'block',
    },
}));

export const VendorSubscriptionDialog = (props: VendorSubscriptionDialogProps) => {
    const { rate, onClose, isoCode } = props;
    const action = useAction();
    const classes = useStyles();
    const paymentStatus = useSelector(subscriptionPaymentStatusSelector);
    const isUIEnabled = useSelector(isUIEnabledSelector);
    const [requestInvoice, setRequestInvoice] = useState(false);
    const [requestInvoiceData, setRequestInvoiceData] = useState(null);
    const { t } = i18n.useTranslation();

    useEffect(() => {
        getRequest(Endpoint.REQUISITES)
            .then(response => {
                if (!response.data?.email) {
                    getRequest(Endpoint.PROFILE)
                        .then(profileResponse => {
                            setRequestInvoiceData({
                                userId: response.data?.userId || USER_INVOICE_DATA.userId,
                                requisites: response.data?.requisites || USER_INVOICE_DATA.requisites,
                                email: profileResponse.data?.email || USER_INVOICE_DATA.email,
                            });
                        })
                        .catch(captureException);
                } else {
                    setRequestInvoiceData({
                        userId: response.data?.userId || USER_INVOICE_DATA.userId,
                        requisites: response.data?.requisites || USER_INVOICE_DATA.requisites,
                        email: response.data?.email || USER_INVOICE_DATA.email,
                    });
                }
            })
            .catch(captureException);
    }, [requestInvoice]);

    const onRequest = (data: RequestInvoiceFormData) => action(makeSubscriptionRequestPriorityAction, rate, data);
    const onResume = () => action(makeSubscriptionResumeAction, rate);

    return (
        // <DialogNew
        //     onClose={onClose}
        //     width={573}
        //     contentStyles={classes.dialog}
        //     title={t('vendor:userMenu.subscription.dialog.connect')}
        // >
        <Box p={2}>
            <ErrorBoundary>
                <div>
                    <Box ml={0} m={2}>
                        <Text typography={TextTypography.TITLE_ACCENT}>
                            {t('vendor:userMenu.subscription.dialog.rate', {
                                rate: getTranslationForEnum(TranslatableEnum.STORE_TYPE_RATE, rate),
                            })}
                        </Text>
                    </Box>
                    {/* <Box ml={0} m={2}>
                        <Text typography={TextTypography.PARA}>
                            {t('vendor:userMenu.subscription.dialog.rate', {
                                rate: getTranslationForEnum(TranslatableEnum.STORE_TYPE_RATE, rate),
                            })}
                        </Text>
                    </Box> */}

                    <div className={classes.buttons}>
                        <Box width="100%" m={1} ml={1} mr={1}>
                            <LargeButton
                                color={LargeButtonColor.LIGHT}
                                disabled={!isUIEnabled}
                                onClick={() => setRequestInvoice(true)}
                            >
                                {t('vendor:userMenu.subscription.dialog.bill')}
                            </LargeButton>
                        </Box>
                        {isoCode === SupportedCountryCodes.RUS && (
                            <Box width="100%" m={1} ml={1} mr={1}>
                                <LargeButton onClick={onResume} disabled={!isUIEnabled}>
                                    {t('vendor:userMenu.subscription.dialog.creditCard')}
                                </LargeButton>
                            </Box>
                        )}
                    </div>
                    {paymentStatus === SubscriptionPaymentStatus.FORM && <VendorSubscriptionNewCard />}
                    {requestInvoice && requestInvoiceData && (
                        <RequestInvoiceForm initialValues={requestInvoiceData} onSubmit={onRequest} />
                    )}
                </div>
            </ErrorBoundary>
            </Box>
        // </DialogNew>
    );
};
